module.exports = __webpack_public_path__ + "header-profile-skin-1.85efa900c0fc12fee15a.png";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/patterns/header-profile-skin-1.png
// module id = 603
// module chunks = 2